import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import { ReportsApi } from '../../../api/Corporates/Reports'
import { dateFormat, moneyColumn, numVal } from '../../../modules/Utils'
import { StyledStrong } from '../../../components/Common/Amount'
import { Row, Table } from 'antd'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import moment from 'moment'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import { Link } from 'react-router-dom'
import OrganisationsSelect from '../../../elements/Select/Organistaions'

Receivable.propTypes = {}

function Receivable(props) {
  const [company, setCompany] = React.useState([])

  const { list, fetch, fetching } = useFetchList(
    () => ReportsApi.receivable(company),
    [company],
    undefined,
    undefined,
    { data: [], periods: [] }
  )
  const columns = [
    {
      title: <strong>Name</strong>,
      dataIndex: 'name',
      style: {
        textAlign: 'left',
        // marginLeft: '0.5rem',
      },
      render: (value, original) => {
        if (original._key)
          return (
            <Link target={'_blank'} to={`/clients/invoices/${original._key}/view`}>
              {value}
            </Link>
          )

        return original.style ? (
          <strong
            style={{
              textTransform: 'uppercase',
              textAlign: 'left',
            }}>
            {value}
          </strong>
        ) : (
          <span style={{ marginLeft: '1rem', fontSize: original.children && '1rem' }}>{value}</span>
        )
      },
    },
    {
      title: <strong>Status</strong>,
      dataIndex: 'status',
      style: {
        textAlign: 'left',
      },
      render: (value, original) => <StatusCell value={value} />,
    },
    {
      title: <strong>Due Date</strong>,
      dataIndex: 'date',
      style: {
        textAlign: 'left',
      },
      render: (value, original) => <span style={{ marginLeft: '1rem' }}>{value && dateFormat(moment(value))}</span>,
    },
    ...list.periods.map((r) => ({
      title: <strong>{r.name}</strong>,
      dataIndex: r.name,
      render: (value, original) =>
        value && (
          <span
            style={{
              fontSize: '1rem',
              textTransform: 'uppercase',
              textAlign: 'left',
              fontWeight: original.style && 'bold',
            }}>
            {value < 0
              ? `(${moneyColumn(numVal({ value: value * -1 }, 'value'))})`
              : moneyColumn(numVal({ value }, 'value'))}
          </span>
        ),
      headerStyle: {
        textAlign: 'right',
      },
      style: {
        textAlign: 'right',
      },
    })),
    {
      title: <strong>Total</strong>,
      dataIndex: 'total',
      style: {
        textAlign: 'right',
        fontSize: '1rem',
        textTransform: 'uppercase',
        fontWeight: 'bold',
      },
      render: (value, original) => (
        <strong
          style={{
            textAlign: 'right',
            fontSize: '1.2rem',
            textTransform: 'uppercase',
            fontWeight: 'bold',
          }}>
          {value && moneyColumn(numVal({ value }, 'value'))}
        </strong>
      ),
      // ),
    },
  ]

  return (
    <Table
      title={() => (
        <Row>
          <StyledStrong>Consolidated Receivables Report (USD)</StyledStrong>
          <RefreshButton onClick={fetch} />
          <OrganisationsSelect
            value={company}
            onChange={(value) => setCompany(value)}
            mode="multiple"
            style={{ float: 'right', marginRight: '1rem', width: '50rem' }}
          />
        </Row>
      )}
      pagination={{ pageSize: 50 }}
      loading={fetching}
      columns={columns}
      dataSource={list.data}
      rowKey={'name'}
    />
  )
}

export default Receivable
